import {api} from "../plugins/axios";
import {BranchDto} from "../types/branch";

export const getBranches = () => {
    return api.get<BranchDto[]>('/branches');
}